/**
 * Route → primary nav page id.
 * Kept pure so we can assert that /users/:id never falls through to "maps"
 * (map shell locks document overflow).
 */
export function resolveCurrentPage(pathname = '') {
  const path = pathname || '';

  if (path === '/' || path === '/home' || path === '/maps') return 'maps';
  if (path.startsWith('/clubs/') && path.endsWith('/map')) return 'clubs';
  if (path.startsWith('/clubs')) return 'clubs';
  if (path.startsWith('/hunting-buddies')) return 'hunting-buddies';
  if (path.startsWith('/users/')) return 'hunting-buddies';
  if (path.startsWith('/community/suggest-store')) return 'suggest-store';
  if (path.startsWith('/community/find-club')) return 'find-club';
  if (path.startsWith('/community/find-processor')) return 'find-processor';
  if (path.startsWith('/camp-essentials')) return 'camp-essentials';
  if (path === '/messages' || path.startsWith('/messages/')) return 'messages';
  if (path === '/notifications') return 'notifications';
  if (path === '/hunts' || path.startsWith('/hunts/')) return 'hunts';
  if (path === '/profile' || path.startsWith('/profile/')) return 'profile';
  if (path.startsWith('/toolkit')) return 'toolkit';
  return 'maps';
}
